import { useEffect, useState } from "react"

export default function ToggleButton(props) {

    const { onToggle, id, defaultChecked, label, className,disable } = props
    const [checked, setChecked] = useState(defaultChecked === 1 || defaultChecked === true)
    const [mount, setMount] = useState(false)
    useEffect(() => {
        if (!mount) {
            setMount(true)
            return
        }
        setChecked(defaultChecked)
    }, [defaultChecked])

    return <div className="form-group" style={{ display: 'flex' }} >
        {label && <label >{label}</label>}

        <label className={`switch ${className}`}  >

            <input disabled={disable}  id={id} type="checkbox" defaultChecked={checked} onChange={(e) => {
                setChecked(!checked)
                onToggle(e)
            }} />
            <span></span>

        </label>
    </div>


}